import EntryCard from "./EntryCard";
import "../../styles/visualization/gridView.css";

const GridView = ({ entries, currentFolderPath }) => {
  return (
    <div className="folder-grid-view">
      {entries.map((entry, idx) => (
        <EntryCard
          key={entry.itemId}
          entry={entry}
          index={idx + 1}
          currentFolderPath={currentFolderPath}
        />
      ))}
    </div>
  );
};

export default GridView;
